import { observer } from 'mobx-react-lite'
import React from 'react'

import { VimeoEmbed } from './VimeoEmbed'
import { YoutubeEmbed } from './YouTubeEmbed'

export const JumbotronVideo = observer(function JumbotronVideo({
  url
}: {
  url: string
}): React.ReactElement | null {
  if (isYoutubeUrl(url)) return <YoutubeEmbed url={url} />
  if (isVimeoUrl(url)) return <VimeoEmbed url={url} />

  return null
})

function isVimeoUrl(url: string) {
  const exp = new RegExp(/(vimeo\.com)/)
  return exp.test(url)
}

function isYoutubeUrl(url: string) {
  const exp = new RegExp(/(youtu\.be|youtube\.com)/)
  return exp.test(url)
}
